import React, { useCallback, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { useMediaQuery, useTheme } from '@mui/material'

import NavigationMenu from 'components_new/molecules/NavigationMenu'
import MetricsDialog from 'components_new/organisms/dialogs/MetricsDialog'

import { useNavigationActions } from 'redux/actions/NavigationMenu'
import { useNavigation } from 'redux/hooks/NavigationMenuStore'
import { useTranslation } from 'language/translator'
import { useExportTableActions } from 'redux/actions/ExportTables'
import { useIsCreatingExportTable } from 'redux/hooks/ExportTables'
import { getMetricTitle } from 'utils/metric'

const TABLES_NAV_MENU_ID = 'tables-nav-menu'

const TablesNavigation = () => {
  const { t, lang, translateEnum } = useTranslation()
  const history = useHistory()
  const { open, expandedItems } = useNavigation()
  const { toggleNavigationItem } = useNavigationActions()
  const { tryCreateExportTable } = useExportTableActions()
  const isCreatingExportTable = useIsCreatingExportTable()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('mobile'), {
    noSsr: true
  })

  const [dialogOpen, setDialogOpen] = useState(false)

  const handleAdd = useCallback(() => {
    setDialogOpen(true)
  }, [])

  if (isMobile) return null

  const items = [
    {
      activePattern: '/export-tables',
      icon: { name: 'Table' } as const,
      inactiveOnSearch: true,
      href: '/export-tables',
      title: t('export_tables', 'all_tables')
    }
  ]

  return (
    <>
      <MetricsDialog
        availableSteps={['variant', 'slices']}
        creating={isCreatingExportTable}
        handleOnAdd={(metric, settings) => {
          const title = getMetricTitle(metric, settings, lang, translateEnum)

          tryCreateExportTable(
            {
              data: {
                kpi_id: metric.id,
                // distribution + rolling?
                variant_kpi_template_id: settings.variant_kpi_template_id,
                slices: settings.slices,
                title
              }
            },
            (err, data) => {
              if (!err) {
                setDialogOpen(false)

                if (data) {
                  history.push(`/export-tables/${data.id}`)
                }
              }
            }
          )
        }}
        onClose={() => setDialogOpen(false)}
        open={dialogOpen}
        title={t('export_tables', 'choose_metric')}
        variant="export_tables"
      />
      <NavigationMenu
        collapsed={{
          activePattern: '/export-tables*',
          href: '/export-tables',
          iconName: 'Table',
          value: !open
        }}
        expandedItems={expandedItems}
        id={TABLES_NAV_MENU_ID}
        items={items}
        loading={false}
        onAdd={handleAdd}
        toggleNavigationItem={(id) => {
          toggleNavigationItem(id)
        }}
        title={t('export_tables', 'tables')}
      />
    </>
  )
}

export default TablesNavigation
